module.exports = __webpack_public_path__ + "static/ecoelephanttoy-51dac0a3d5cf6c274821794bc416a2ea.jpeg";